module.exports = __webpack_public_path__ + "static/media/com.06a79be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/WorstDrivers/com.png
// module id = 219
// module chunks = 0